import React, { useState, useContext, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  modalLoading,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Moment from "react-moment";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { UserContext } from "../../../../../contexts/User";
import { FoodContext } from "../../../../../contexts/Food";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";
import DataTable from "../../../../common/DataTable";
import { useCustomHooks } from "../../../../../functions/Hooks";

const AdminStaffCrud = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { availableDeliveryTypes, availableDeliveryParties } = useCustomHooks();
  //getting context values here
  let {
    //common
    loading,
    setLoading,
    //permission group
    permissionGroupForSearch,
  } = useContext(SettingsContext);

  const { foodDeptForSearch } = useContext(FoodContext);

  let {
    //adminStaff
    adminStaffList,
    setAdminStaffList,
    setPaginatedAdminStaff,
    adminStaffForSearch,
    setAdminStaffListforSearch,

    //pagination
    dataPaginating,
    partyForSearch,
    getParty,
  } = useContext(UserContext);

  let {
    //branch
    branchForSearch,
    orderTypeForSearch,
    getOrderType,
  } = useContext(RestaurantContext);

  // States hook here
  const selectRef = useRef(null);
  // close btn
  const closeBtnRef = useRef(null);
  const handleInvalid = () => {
    if (!selectRef.current?.value) {
      selectRef.current.setCustomValidity('Please select an user type in the list');
    } else {
      selectRef.current.setCustomValidity('');
    }
  };
  //new adminStaff
  let [newAdminStaff, setAdminStaff] = useState({
    id: null,
    user_type: "",
    name: "",
    email: "",
    phn_no: "0",
    password: "",
    password_confirmation: "",
    sales_limit: 0,
    branch: null,
    user_passcode: "",
    selectedBranch: null,
    selectPermissionGroup: null,
    selectedPermissionGroup: null,
    user_dept: "",
    sbr_pos_id: "",
    sbr_ntn: "",
    sbr_user_id: "",
    sbr_user_password: "",
    sbr_integration: 0,
    foc_limit: 0,
    is_cashier: 0,
    tillUser: null,
    orderType: null,
    default_order: null,
    default_party: null,
    image: null,
    edit: false,
    editSlug: null,
    editImage: null,
    uploading: false,
    app_type: "",
  });

  //search result
  let [searchedAdminStaff, setSearchedAdminStaff] = useState({
    list: null,
    searched: false,
  });

  const [tillList, setTillList] = useState([]);
  const [modalFetching, setModalFetching] = useState(false);
  const searchInputRef = useRef(null);

  const getTillUserBranch = () => {
    setLoading(true);
    const url = BASE_URL + "/settings/till-list";
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setTillList(res.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }

  //useEffect == componentDidMount
  useEffect(() => {
    getTillUserBranch();
    if (!orderTypeForSearch && getOrderType) {
      getOrderType();
    }
    if (!partyForSearch && getParty) {
      getParty();
    }
  }, []);

  // set admin staff usertype
  const handleSetNewUserType = (e) => {
    let app_type = newAdminStaff.app_type;
    if (e.target.name === "user_type") {
      if (e.target.value === "waiter") app_type = "waiter";
      else if (e.target.value === "staff") app_type = "";
    }
    if (newAdminStaff.user_type !== e.target.value) {
      setAdminStaff({ ...newAdminStaff, [e.target.name]: e.target.value, branch: null, selectedBranch: null, app_type });
    } else {
      setAdminStaff({ ...newAdminStaff, [e.target.name]: e.target.value, app_type });
    }
  };

  //set name, phn no hook
  const handleSetNewAdminStaff = (e) => {
    const value = e.target.type === "checkbox" ? (e.target.checked ? 1 : 0) : e.target.value;
    setAdminStaff({ ...newAdminStaff, [e.target.name]: value });
  };

  //set branch hook
  const handleSetBranch = (branch) => {
    setAdminStaff({ ...newAdminStaff, branch });
  };

  //set branch hook
  const handleSetDept = (dept) => {
    setAdminStaff({ ...newAdminStaff, user_dept: dept });
  };

  //set permission hook
  const handleSetPermissionGroup = (selectPermissionGroup) => {
    setAdminStaff({ ...newAdminStaff, selectPermissionGroup });
  };

  //till user
  const handleSetTillUser = (tillUser) => {
    if (tillUser) {
      setAdminStaff({
        ...newAdminStaff, tillUser,
        sbr_integration: tillUser?.sbr_pos_id ? 1 : 0,
        sbr_pos_id: tillUser.sbr_pos_id || "",
        sbr_ntn: tillUser.sbr_ntn || "",
        sbr_user_id: tillUser.sbr_user_id || "",
        sbr_user_password: tillUser.sbr_user_password || "",
      });
    } else {
      setAdminStaff({
        ...newAdminStaff, tillUser,
        sbr_integration: 0,
        sbr_pos_id: "",
        sbr_ntn: "",
        sbr_user_id: "",
        sbr_user_password: "",
      });
    }
  }

  //set permission hook
  const handleSetOrderTypeGroup = (orderType) => {
    setAdminStaff({ ...newAdminStaff, orderType });
  };

  //set default order hook
  const handleSetDefaultOrder = (default_order) => {
    setAdminStaff({ ...newAdminStaff, default_order });
  };

  //set default party hook
  const handleSetDefaultParty = (default_party) => {
    setAdminStaff({ ...newAdminStaff, default_party });
  };

  //helper to format ODT - Party display
  const getOdtPartyDisplay = (item) => {
    if (item?.default_order_name && item?.default_party_name) {
      return `${item.default_order_name} - ${item.default_party_name}`;
    }
    if (item?.default_order_name) {
      return item.default_order_name;
    }
    if (item?.default_party_name) {
      return item.default_party_name;
    }
    if (item?.default_order_id || item?.default_party_id) {
      const order =
        orderTypeForSearch &&
        orderTypeForSearch.find((o) => o.id == item.default_order_id);
      const party =
        partyForSearch &&
        partyForSearch.find((p) => p.id == item.default_party_id);
      if (order?.name && party?.name) {
        return `${order.name} - ${party.name}`;
      }
      if (order?.name) return order.name;
      if (party?.name) return party.name;
    }
    return "-";
  };
  //set image hook
  const handleAdminStaffImage = (e) => {
    setAdminStaff({
      ...newAdminStaff,
      [e.target.name]: e.target.files[0],
    });
  };

  //Save New adminStaff
  const handleSaveNewAdminStaff = (e) => {
    e.preventDefault();
    //url and form data
    const adminStaffUrl = BASE_URL + `/settings/new-admin-staff`;
    let formData = new FormData();

    let orderTypes = []
    if (newAdminStaff.user_type !== "admin" && newAdminStaff.user_type !== "superAdmin" && newAdminStaff.user_type !== "multi_manager") {
      newAdminStaff.orderType?.length > 0 && newAdminStaff.orderType.forEach((order_type) => {
        orderTypes.push(order_type.id)
      });
    }
    const userDept = newAdminStaff?.user_dept && Array.isArray(newAdminStaff.user_dept) ? (newAdminStaff.user_dept?.length ? newAdminStaff.user_dept.map((item) => item.id) : "") : (newAdminStaff.user_dept ? [newAdminStaff.user_dept?.id] : "");

    formData.append("user_type", newAdminStaff.user_type);
    formData.append("name", newAdminStaff.name);
    formData.append("email", newAdminStaff.email);
    formData.append("phn_no", newAdminStaff.phn_no);
    formData.append("password", newAdminStaff.password);
    formData.append("user_passcode", newAdminStaff.user_passcode ? newAdminStaff.user_passcode : "");
    formData.append("order_type_id", JSON.stringify(orderTypes));
    formData.append("default_order_id", newAdminStaff.default_order ? newAdminStaff.default_order.id : "");
    formData.append("default_party_id", newAdminStaff.default_party ? newAdminStaff.default_party.id : "");
    formData.append("app_type", newAdminStaff.app_type || "");

    formData.append("foc_limit", newAdminStaff.foc_limit || 0);
    formData.append("is_cashier", newAdminStaff.is_cashier ? 1 : 0);

    if (userDept) {
      formData.append("user_dept_id", JSON.stringify(userDept));
    }

    formData.append(
      "password_confirmation",
      newAdminStaff.password_confirmation
    );
    formData.append(
      "sales_limit",
      newAdminStaff.sales_limit
    );
    if (newAdminStaff.selectPermissionGroup !== null) {
      formData.append(
        "permission_group_id",
        newAdminStaff.selectPermissionGroup.id
      );
    }
    if (
      (newAdminStaff.user_type === "staff" ||
        newAdminStaff.user_type === "waiter" ||
        newAdminStaff.user_type === "manager" ||
        newAdminStaff.user_type === "call_center") &&
      newAdminStaff.default_order &&
      newAdminStaff.orderType &&
      newAdminStaff.orderType.length > 0
    ) {
      const isDefaultOrderIncluded = newAdminStaff.orderType.some(
        (ot) => ot.id == newAdminStaff.default_order.id
      );
      if (!isDefaultOrderIncluded) {
        toast.error(
          `${_t(t("Default order type must be included in selected order types"))}`,
          {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }
        );
        return false;
      }
    }
    if ((newAdminStaff.user_type === "staff" || newAdminStaff.user_type === "waiter" || newAdminStaff.user_type === "manager" || newAdminStaff.user_type === "multi_manager") && (newAdminStaff.branch === null || newAdminStaff.branch === "")) {
      toast.error(
        `${_t(t("Please select branch"))}`,
        {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
      return false;
    }

    if ((newAdminStaff.user_type === "staff" || newAdminStaff.user_type === "waiter" || newAdminStaff.user_type === "manager" || newAdminStaff.user_type === "multi_manager") && newAdminStaff.branch !== null) {
      if (newAdminStaff.user_type === "multi_manager") {
        let branches = newAdminStaff.branch.map((branch) => branch.id);
        formData.append("branch_id", JSON.stringify(branches));
      } else {
        formData.append("branch_id", newAdminStaff.branch.id);
      }
    } else {
      formData.append("branch_id", "");
    }

    if (newAdminStaff.user_type === "staff" || newAdminStaff.user_type === "waiter" || newAdminStaff.user_type === "manager") {
      formData.append("sbr_pos_id", newAdminStaff.sbr_pos_id);
      formData.append("sbr_ntn", newAdminStaff.sbr_ntn);
      formData.append("sbr_user_id", newAdminStaff.sbr_user_id);
      formData.append("sbr_user_password", newAdminStaff.sbr_user_password);
      formData.append("sbr_enabled", newAdminStaff.sbr_integration);
      formData.append("till_id", newAdminStaff.tillUser ? newAdminStaff.tillUser.id : "");
    }

    formData.append("image", newAdminStaff.image);

    //check user type
    if (newAdminStaff.user_type === "staff" || newAdminStaff.user_type === "waiter" || newAdminStaff.user_type === "manager" || newAdminStaff.user_type === "multi_manager") {
      //check if group || branch null
      if (
        newAdminStaff.branch !== null &&
        newAdminStaff.selectPermissionGroup !== null
      ) {
        setAdminStaff({
          ...newAdminStaff,
          uploading: true,
        });

        return axios
          .post(adminStaffUrl, formData, {
            headers: { Authorization: `Bearer ${getCookie()}` },
          })
          .then((res) => {
            setAdminStaff({
              id: null,
              user_type: "",
              name: "",
              email: "",
              phn_no: "0",
              password: "",
              password_confirmation: "",
              sales_limit: 0,
              branch: null,
              selectPermissionGroup: null,
              selectedBranch: null,
              selectedPermissionGroup: null,
              user_dept: "",
              sbr_pos_id: "",
              sbr_ntn: "",
              sbr_user_id: "",
              sbr_user_password: "",
              sbr_integration: 0,
              foc_limit: 0,
              is_cashier: 0,
              tillUser: null,
              orderType: null,
              default_order: null,
              default_party: null,
              image: null,
              edit: false,
              editSlug: null,
              editImage: null,
              uploading: false,
            });
            setAdminStaffList(res.data[0]);
            setAdminStaffListforSearch(res.data[1]);
            setLoading(false);
            toast.success(`${_t(t("User has been added"))}`, {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
            if (closeBtnRef.current) {
              closeBtnRef.current.click();
            }
          })
          .catch((error) => {
            setLoading(false);
            setAdminStaff({
              ...newAdminStaff,
              uploading: false,
            });
            if (error && error.response.data.errors) {
              if (error.response.data.errors.phn_no) {
                error.response.data.errors.phn_no.forEach((item) => {
                  if (item === "An user exists with this phone number") {
                    toast.error(
                      `${_t(t("An user exists with this phone number"))}`,
                      {
                        position: "bottom-center",
                        autoClose: 10000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        className: "text-center toast-notification",
                      }
                    );
                  }
                });
              }
              if (error.response.data.errors.email) {
                error.response.data.errors.email.forEach((item) => {
                  if (item === "An user exists with this email") {
                    toast.error(`${_t(t("An user exists with this email"))}`, {
                      position: "bottom-center",
                      autoClose: 10000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      className: "text-center toast-notification",
                    });
                  }
                });
              }
              if (error.response.data.errors.password) {
                error.response.data.errors.password.forEach((item) => {
                  if (item === "Password confirmation does not match") {
                    toast.error(
                      `${_t(t("Password confirmation does not match"))}`,
                      {
                        position: "bottom-center",
                        autoClose: 10000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        className: "text-center toast-notification",
                      }
                    );
                  }
                  if (item === "The password must be at least 6 characters.") {
                    toast.error(
                      `${_t(t("The password must be at least 6 characters"))}`,
                      {
                        position: "bottom-center",
                        autoClose: 10000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        className: "text-center toast-notification",
                      }
                    );
                  }
                });
              }
              if (error.response.data.errors.image) {
                error.response.data.errors.image.forEach((item) => {
                  if (item === "Please select a valid image file") {
                    toast.error(
                      `${_t(t("Please select a valid image file"))}`,
                      {
                        position: "bottom-center",
                        autoClose: 10000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        className: "text-center toast-notification",
                      }
                    );
                  }
                  if (item === "Please select a file less than 5MB") {
                    toast.error(
                      `${_t(t("Please select a file less than 5MB"))}`,
                      {
                        position: "bottom-center",
                        autoClose: 10000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        className: "text-center toast-notification",
                      }
                    );
                  }
                });
              }
            }
          });
      } else {
        if (newAdminStaff.branch === null) {
          toast.error(`${_t(t("Please select a branch"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }
        if (newAdminStaff.selectPermissionGroup === null) {
          toast.error(`${_t(t("Please select a permission group"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }
      }
    } else {
      //check if group null
      if (newAdminStaff.selectPermissionGroup !== null) {
        setAdminStaff({
          ...newAdminStaff,
          uploading: true,
        });
        return axios
          .post(adminStaffUrl, formData, {
            headers: { Authorization: `Bearer ${getCookie()}` },
          })
          .then((res) => {
            setAdminStaff({
              id: null,
              user_type: "",
              name: "",
              email: "",
              phn_no: "0",
              password: "",
              password_confirmation: "",
              sales_limit: 0,
              branch: null,
              selectPermissionGroup: null,
              selectedBranch: null,
              selectedPermissionGroup: null,
              user_dept: "",
              sbr_pos_id: "",
              sbr_ntn: "",
              sbr_user_id: "",
              sbr_user_password: "",
              sbr_integration: 0,
              foc_limit: 0,
              is_cashier: 0,
              tillUser: null,
              orderType: null,
              default_order: null,
              default_party: null,
              image: null,
              edit: false,
              editSlug: null,
              editImage: null,
              uploading: false,
            });
            setAdminStaffList(res.data[0]);
            setAdminStaffListforSearch(res.data[1]);
            setLoading(false);
            if (closeBtnRef.current) {
              closeBtnRef.current.click();
            }
            toast.success(`${_t(t("User has been added"))}`, {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
          })
          .catch((error) => {
            setLoading(false);
            setAdminStaff({
              ...newAdminStaff,
              branch: null,
              selectPermissionGroup: null,
              uploading: false,
            });
            if (error && error.response.data.errors) {
              if (error.response.data.errors.phn_no) {
                error.response.data.errors.phn_no.forEach((item) => {
                  if (item === "An user exists with this phone number") {
                    toast.error(
                      `${_t(t("An user exists with this phone number"))}`,
                      {
                        position: "bottom-center",
                        autoClose: 10000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        className: "text-center toast-notification",
                      }
                    );
                  }
                });
              }
              if (error.response.data.errors.email) {
                error.response.data.errors.email.forEach((item) => {
                  if (item === "An user exists with this email") {
                    toast.error(`${_t(t("An user exists with this email"))}`, {
                      position: "bottom-center",
                      autoClose: 10000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      className: "text-center toast-notification",
                    });
                  }
                });
              }

              if (error.response.data.errors.password) {
                error.response.data.errors.password.forEach((item) => {
                  if (item === "The password confirmation does not match.") {
                    toast.error(
                      `${_t(t("Password confirmation does not match"))}`,
                      {
                        position: "bottom-center",
                        autoClose: 10000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        className: "text-center toast-notification",
                      }
                    );
                  }
                  if (item === "The password must be at least 6 characters.") {
                    toast.error(
                      `${_t(t("The password must be at least 6 characters"))}`,
                      {
                        position: "bottom-center",
                        autoClose: 10000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        className: "text-center toast-notification",
                      }
                    );
                  }
                });
              }
              if (error.response.data.errors.image) {
                error.response.data.errors.image.forEach((item) => {
                  if (item === "Please select a valid image file") {
                    toast.error(
                      `${_t(t("Please select a valid image file"))}`,
                      {
                        position: "bottom-center",
                        autoClose: 10000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        className: "text-center toast-notification",
                      }
                    );
                  }
                  if (item === "Please select a file less than 5MB") {
                    toast.error(
                      `${_t(t("Please select a file less than 5MB"))}`,
                      {
                        position: "bottom-center",
                        autoClose: 10000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        className: "text-center toast-notification",
                      }
                    );
                  }
                });
              }
            }
          });
      } else {
        toast.error(`${_t(t("Please select a permission group"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    }
  };

  //set edit true & values
  const handleSetEdit = async (id) => {
    setModalFetching(true);
    try {
      const url = BASE_URL + '/settings/edit-admin-staff/' + id;

      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });

      if (res) {
        const adminStaff = res.data;
        let selectedOptionForPermission = null;
        if (adminStaff?.permission_group_id) {
          selectedOptionForPermission = permissionGroupForSearch && permissionGroupForSearch.find(
            (groupItem) => {
              return groupItem.id === parseInt(adminStaff.permission_group_id);
            }
          );
        }

        let orderType = null;
        if (adminStaff?.order_type_id && JSON.parse(adminStaff.order_type_id)?.length > 0) {
          orderType = orderTypeForSearch && orderTypeForSearch.filter(
            (order_type) => {
              return JSON.parse(adminStaff.order_type_id).includes(order_type.id);
            }
          );
        }

        let selectedDefaultOrder = null;
        if (adminStaff?.default_order_id) {
          selectedDefaultOrder = {
              id: adminStaff.default_order_id,
              name: adminStaff.default_order_name,
            }
        }

        let selectedDefaultParty = null;
        if (adminStaff?.default_party_id) {
          selectedDefaultParty = {
              id: adminStaff.default_party_id,
              name: adminStaff.default_party_name,
            }
        }

        let till = null;
        if (adminStaff?.till_id && adminStaff.branch_id && (adminStaff.user_type === "staff" || adminStaff.user_type === "manager" || adminStaff.user_type === "waiter")) {
          till = tillList && tillList[adminStaff.branch_id] && tillList[adminStaff.branch_id].find((item) => item.id == adminStaff.till_id);
        }

        //user dept
        const userDept = adminStaff.user_departments?.length ? adminStaff.user_departments.map((item) => {
          return (
            { ...item.department }
          )
        }) : "";

        if (adminStaff.user_type === "staff" || adminStaff.user_type === "manager" || adminStaff.user_type === "multi_manager" || adminStaff.user_type === "waiter") {
          let selectedOptionForBranch = null;
          if (adminStaff.branch_id && adminStaff.user_type === "multi_manager") {
            selectedOptionForBranch =
              branchForSearch !== null &&
              branchForSearch.filter((branchItem) => {
                return adminStaff.branch_id.includes(branchItem.id);
              });
          } else if (adminStaff.branch_id) {
            selectedOptionForBranch =
              branchForSearch !== null &&
              branchForSearch.find((branchItem) => {
                return branchItem.id === adminStaff.branch_id;
              });
          }

          setAdminStaff({
            ...newAdminStaff,
            id: adminStaff.id,
            user_type: adminStaff.user_type,
            name: adminStaff.name,
            email: adminStaff.email,
            phn_no: adminStaff.phn_no,
            user_passcode: adminStaff.user_passcode,
            selectedBranch: selectedOptionForBranch || null,
            branch: selectedOptionForBranch || null,
            sales_limit: adminStaff.sales_limit || 0,
            foc_limit: adminStaff?.foc_limit || 0,
            is_cashier: (adminStaff?.is_cashier === true || parseInt(adminStaff?.is_cashier) === 1) ? 1 : 0,
            app_type: adminStaff?.app_type || "",
            user_dept: userDept,
            sbr_pos_id: adminStaff.sbr_pos_id || "",
            sbr_ntn: adminStaff.sbr_ntn || "",
            sbr_user_id: adminStaff.sbr_user_id || "",
            sbr_user_password: adminStaff.sbr_password || "",
            sbr_integration: adminStaff.sbr_enabled,
            tillUser: till,
            selectPermissionGroup: selectedOptionForPermission || null,
            orderType: orderType ? orderType : null,
            default_order: selectedDefaultOrder || null,
            default_party: selectedDefaultParty || null,
            editSlug: adminStaff.slug,
            editImage: adminStaff.image,
            edit: true,
          });
        } else {
          setAdminStaff({
            ...newAdminStaff,
            id: adminStaff.id,
            user_type: adminStaff.user_type,
            name: adminStaff.name,
            email: adminStaff.email,
            phn_no: adminStaff.phn_no,
            user_passcode: adminStaff.user_passcode,
            sales_limit: adminStaff.sales_limit || 0,
            foc_limit: adminStaff?.foc_limit || 0,
            is_cashier: (adminStaff?.is_cashier === true || parseInt(adminStaff?.is_cashier) === 1) ? 1 : 0,
            app_type: adminStaff?.app_type || "",
            user_dept: userDept,
            sbr_pos_id: adminStaff.sbr_pos_id || "",
            sbr_ntn: adminStaff.sbr_ntn || "",
            sbr_user_id: adminStaff.sbr_user_id || "",
            sbr_user_password: adminStaff.sbr_user_password || "",
            sbr_integration: adminStaff.sbr_enabled,
            tillUser: till,
            selectPermissionGroup: selectedOptionForPermission || null,
            orderType: orderType ? orderType : null,
            default_order: selectedDefaultOrder || null,
            default_party: selectedDefaultParty || null,
            editSlug: adminStaff.slug,
            editImage: adminStaff.image,
            edit: true,
          });
        }
      }
    } catch {
      toast.error("Please try again", {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    } finally {
      setModalFetching(false);
    }

  };

  //update adminStaff
  const handleUpdateAdminStaff = (e) => {
    e.preventDefault();
    //url and form data
    const adminStaffUrl = BASE_URL + `/settings/update-admin-staff`;
    let formData = new FormData();

    let orderTypes = [];
    if (newAdminStaff.user_type !== "admin" && newAdminStaff.user_type !== "superAdmin" && newAdminStaff.user_type !== "multi_manager") {
      newAdminStaff.orderType?.length > 0 && newAdminStaff.orderType.forEach((order_type) => {
        orderTypes.push(order_type.id)
      });
    }

    const userDept = newAdminStaff?.user_dept && Array.isArray(newAdminStaff.user_dept) ? (newAdminStaff.user_dept?.length ? newAdminStaff.user_dept.map((item) => item.id) : "") : (newAdminStaff.user_dept ? [newAdminStaff.user_dept?.id] : "");

    formData.append("id", newAdminStaff.id);
    formData.append("user_type", newAdminStaff.user_type);
    formData.append("name", newAdminStaff.name);
    formData.append("email", newAdminStaff.email);
    formData.append("phn_no", newAdminStaff.phn_no);
    formData.append("password", newAdminStaff.password);
    formData.append("user_passcode", newAdminStaff.user_passcode ? newAdminStaff.user_passcode : "");
    formData.append("order_type_id", JSON.stringify(orderTypes));
    formData.append("default_order_id", newAdminStaff.default_order ? newAdminStaff.default_order.id : "");
    formData.append("default_party_id", newAdminStaff.default_party ? newAdminStaff.default_party.id : "");
    formData.append("app_type", newAdminStaff.app_type || "");

    formData.append("foc_limit", newAdminStaff.foc_limit || 0);
    formData.append("is_cashier", newAdminStaff.is_cashier ? 1 : 0);

    if (userDept) {
      formData.append("user_dept_id", JSON.stringify(userDept));
    }

    formData.append(
      "password_confirmation",
      newAdminStaff.password_confirmation
    );
    formData.append(
      "sales_limit",
      newAdminStaff.sales_limit
    );

    if (newAdminStaff.selectPermissionGroup !== null) {
      formData.append(
        "permission_group_id",
        newAdminStaff.selectPermissionGroup.id
      );
    }
    if (
      (newAdminStaff.user_type === "staff" ||
        newAdminStaff.user_type === "waiter" ||
        newAdminStaff.user_type === "manager" ||
        newAdminStaff.user_type === "call_center") &&
      newAdminStaff.default_order &&
      newAdminStaff.orderType &&
      newAdminStaff.orderType.length > 0
    ) {
      const isDefaultOrderIncluded = newAdminStaff.orderType.some(
        (ot) => ot.id == newAdminStaff.default_order.id
      );
      if (!isDefaultOrderIncluded) {
        toast.error(
          `${_t(t("Default order type must be included in selected order types"))}`,
          {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }
        );
        return false;
      }
    }
    if ((newAdminStaff.user_type === "staff" || newAdminStaff.user_type === "waiter" || newAdminStaff.user_type === "manager" || newAdminStaff.user_type === "multi_manager") && (newAdminStaff.branch === null || newAdminStaff.branch === "")) {
      toast.error(
        `${_t(t("Please select branch"))}`,
        {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
      return false;
    }
    if ((newAdminStaff.user_type === "staff" || newAdminStaff.user_type === "waiter" || newAdminStaff.user_type === "manager" || newAdminStaff.user_type === "multi_manager") && newAdminStaff.branch !== null) {
      if (newAdminStaff.user_type === "multi_manager") {
        let branches = newAdminStaff.branch.map((branch) => branch.id);
        formData.append("branch_id", JSON.stringify(branches));
      } else {
        formData.append("branch_id", newAdminStaff.branch.id);
      }
    } else {
      formData.append("branch_id", "");
    }
    if (newAdminStaff.user_type === "staff" || newAdminStaff.user_type === "manager" || newAdminStaff.user_type === "waiter") {
      formData.append("sbr_pos_id", newAdminStaff.sbr_pos_id);
      formData.append("sbr_ntn", newAdminStaff.sbr_ntn);
      formData.append("sbr_user_id", newAdminStaff.sbr_user_id);
      formData.append("sbr_user_password", newAdminStaff.sbr_user_password);
      formData.append("sbr_enabled", newAdminStaff.sbr_integration);
      formData.append("till_id", newAdminStaff.tillUser ? newAdminStaff.tillUser.id : "");
    }
    formData.append("image", newAdminStaff.image);
    formData.append("editSlug", newAdminStaff.editSlug);

    //check user type
    if (newAdminStaff.user_type === "staff" || newAdminStaff.user_type === "waiter" || newAdminStaff.user_type === "manager" || newAdminStaff.user_type === "multi_manager") {
      setAdminStaff({
        ...newAdminStaff,
        uploading: true,
      });

      return axios
        .post(adminStaffUrl, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setAdminStaff({
            id: null,
            user_type: "",
            name: "",
            email: "",
            phn_no: "0",
            password: "",
            password_confirmation: "",
            sales_limit: 0,
            branch: null,
            selectPermissionGroup: null,
            selectedBranch: null,
            selectedPermissionGroup: null,
            user_dept: "",
            sbr_pos_id: "",
            sbr_ntn: "",
            sbr_user_id: "",
            sbr_user_password: "",
            sbr_integration: 0,
            foc_limit: 0,
            is_cashier: 0,
            tillUser: null,
            orderType: null,
            default_order: null,
            default_party: null,
            image: null,
            edit: false,
            editSlug: null,
            editImage: null,
            uploading: false,
          });
          setAdminStaffList(res.data[0]);
          setAdminStaffListforSearch(res.data[1]);
          setLoading(false);
          toast.success(`${_t(t("User has been updated"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          if (closeBtnRef.current) {
            closeBtnRef.current.click();
          }
        })
        .catch((error) => {
          setLoading(false);
          setAdminStaff({
            ...newAdminStaff,
            uploading: false,
          });
          if (error && error.response.data.errors) {
            if (error.response.data.errors.email) {
              error.response.data.errors.email.forEach((item) => {
                if (item === "An user exists with this email") {
                  toast.error(`${_t(t("An user exists with this email"))}`, {
                    position: "bottom-center",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    className: "text-center toast-notification",
                  });
                }
              });
            }

            if (error.response.data.errors.phn_no) {
              error.response.data.errors.phn_no.forEach((item) => {
                if (item === "An user exists with this phone number") {
                  toast.error(
                    `${_t(t("An user exists with this phone number"))}`,
                    {
                      position: "bottom-center",
                      autoClose: 10000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      className: "text-center toast-notification",
                    }
                  );
                }
              });
            }

            if (error.response.data.errors.password) {
              error.response.data.errors.password.forEach((item) => {
                if (item === "Password confirmation does not match") {
                  toast.error(
                    `${_t(t("Password confirmation does not match"))}`,
                    {
                      position: "bottom-center",
                      autoClose: 10000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      className: "text-center toast-notification",
                    }
                  );
                }
                if (item === "The password must be at least 6 characters.") {
                  toast.error(
                    `${_t(t("The password must be at least 6 characters"))}`,
                    {
                      position: "bottom-center",
                      autoClose: 10000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      className: "text-center toast-notification",
                    }
                  );
                }
              });
            }

            if (error.response.data.errors.image) {
              error.response.data.errors.image.forEach((item) => {
                if (item === "Please select a valid image file") {
                  toast.error(`${_t(t("Please select a valid image file"))}`, {
                    position: "bottom-center",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    className: "text-center toast-notification",
                  });
                }
                if (item === "Please select a file less than 5MB") {
                  toast.error(
                    `${_t(t("Please select a file less than 5MB"))}`,
                    {
                      position: "bottom-center",
                      autoClose: 10000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      className: "text-center toast-notification",
                    }
                  );
                }
              });
            }
          }
        });
    } else {
      setAdminStaff({
        ...newAdminStaff,
        uploading: true,
      });
      return axios
        .post(adminStaffUrl, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setAdminStaff({
            id: null,
            user_type: "",
            name: "",
            email: "",
            phn_no: "0",
            password: "",
            password_confirmation: "",
            sales_limit: 0,
            branch: null,
            selectPermissionGroup: null,
            selectedBranch: null,
            selectedPermissionGroup: null,
            user_dept: "",
            sbr_pos_id: "",
            sbr_ntn: "",
            sbr_user_id: "",
            sbr_user_password: "",
            sbr_integration: 0,
            foc_limit: 0,
            is_cashier: 0,
            tillUser: null,
            orderType: null,
            default_order: null,
            default_party: null,
            image: null,
            edit: false,
            editSlug: null,
            editImage: null,
            uploading: false,
          });
          setAdminStaffList(res.data[0]);
          setAdminStaffListforSearch(res.data[1]);
          setLoading(false);
          if (closeBtnRef.current) {
            closeBtnRef.current.click();
          }
          toast.success(`${_t(t("User has been updated"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        })
        .catch((error) => {
          setLoading(false);
          setAdminStaff({
            ...newAdminStaff,
            branch: null,
            selectPermissionGroup: null,
            uploading: false,
          });
          if (error && error.response.data.errors) {
            if (error.response.data.errors.password) {
              error.response.data.errors.password.forEach((item) => {
                if (item === "The password confirmation does not match.") {
                  toast.error(
                    `${_t(t("Password confirmation does not match"))}`,
                    {
                      position: "bottom-center",
                      autoClose: 10000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      className: "text-center toast-notification",
                    }
                  );
                }
                if (item === "The password must be at least 6 characters.") {
                  toast.error(
                    `${_t(t("The password must be at least 6 characters"))}`,
                    {
                      position: "bottom-center",
                      autoClose: 10000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      className: "text-center toast-notification",
                    }
                  );
                }
              });
            }
            if (error.response.data.errors.phn_no) {
              error.response.data.errors.phn_no.forEach((item) => {
                if (item === "An user exists with this phone number") {
                  toast.error(
                    `${_t(t("An user exists with this phone number"))}`,
                    {
                      position: "bottom-center",
                      autoClose: 10000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      className: "text-center toast-notification",
                    }
                  );
                }
              });
            }
          }
        });
    }
  };

  //search admin staff here
  const handleSearch = (e) => {
    let searchInput = e.target.value?.toLowerCase();
    if (searchInput.length === 0) {
      setSearchedAdminStaff({ ...searchedAdminStaff, searched: false });
    } else {
      let searchedList = adminStaffForSearch.filter((item) => {
        let lowerCaseItemName = item.name?.toLowerCase();
        let lowerCaseItemPhnNo = item.phn_no?.toLowerCase();
        let lowerCaseItemType = item.user_type?.toLowerCase();
        let lowerCaseItemBranch =
          item.branch_name !== null && item.branch_name?.toLowerCase();
        return (
          (lowerCaseItemName && lowerCaseItemName.includes(searchInput)) ||
          (lowerCaseItemPhnNo && lowerCaseItemPhnNo.includes(searchInput)) ||
          (lowerCaseItemType && lowerCaseItemType.includes(searchInput)) ||
          (lowerCaseItemBranch && lowerCaseItemBranch.includes(searchInput))
        );
      });
      setSearchedAdminStaff({
        ...searchedAdminStaff,
        list: searchedList,
        searched: true,
      });
    }
  };

  //disable confirmation modal of adminStaff
  const handleDisableConfirmation = (slug, status) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body bg-danger text-white">
            <h1 className="text-white">{_t(t("Are you sure?"))}</h1>
            <p className="text-center">
              {_t(t(`You want to ${status ? "enable" : "disable"} this user?`))}
            </p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-warning text-dark rounded"
                onClick={() => {
                  handleDisableUser(slug);
                  onClose();
                }}
              >
                {_t(t("Yes, please!"))}
              </button>
              <button className="btn btn-success ml-2 px-3 rounded" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const getRowTextClass = (item) => {
    return parseInt(item.is_banned)
      ? "text-danger"
      : parseInt(item.sbr_enabled)
      ? "text-primary"
      : "";
  };

  const onClearSearch = () => {
    setSearchedAdminStaff({ searched: false, list: null });
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
  };

  const getListData = () => {
    if (searchedAdminStaff.searched) {
      return searchedAdminStaff.list || [];
    }
    return adminStaffList?.data || [];
  };

  const handleFetchData = (page) => {
    setPaginatedAdminStaff(page);
  };

  const handleAddNewClick = () => {
    setModalFetching(false);
    setAdminStaff({
      id: null,
      user_type: "",
      name: "",
      email: "",
      phn_no: "0",
      password: "",
      password_confirmation: "",
      sales_limit: 0,
      branch: null,
      user_passcode: "",
      selectedBranch: null,
      selectPermissionGroup: null,
      selectedPermissionGroup: null,
      user_dept: "",
      sbr_pos_id: "",
      sbr_ntn: "",
      sbr_user_id: "",
      sbr_user_password: "",
      sbr_integration: 0,
      foc_limit: 0,
      is_cashier: 0,
      tillUser: null,
      orderType: null,
      default_order: null,
      default_party: null,
      image: null,
      edit: false,
      editSlug: null,
      editImage: null,
      uploading: false,
      app_type: "",
    });
  };

  const handleOpenEdit = (item) => {
    setModalFetching(true);
    setAdminStaff({
      id: item.id,
      user_type: item.user_type || "",
      name: item.name || "",
      email: item.email || "",
      phn_no: item.phn_no || "",
      password: "",
      password_confirmation: "",
      sales_limit: item.sales_limit || 0,
      branch: null,
      user_passcode: "",
      selectedBranch: null,
      selectPermissionGroup: null,
      selectedPermissionGroup: null,
      user_dept: "",
      sbr_pos_id: item.sbr_pos_id || "",
      sbr_ntn: item.sbr_ntn || "",
      sbr_user_id: item.sbr_user_id || "",
      sbr_user_password: "",
      sbr_integration: item.sbr_enabled || 0,
      foc_limit: item.foc_limit || 0,
      is_cashier: (item.is_cashier === true || parseInt(item.is_cashier) === 1) ? 1 : 0,
      tillUser: null,
      orderType: null,
      default_order: null,
      default_party: null,
      image: null,
      edit: true,
      editSlug: item.slug,
      editImage: item.image,
      uploading: false,
      app_type: item.app_type || "",
    });
    handleSetEdit(item.id);
  };

  const handleOpenView = (item) => {
    setModalFetching(true);
    setAdminStaff({
      id: item.id,
      user_type: item.user_type || "",
      name: item.name || "",
      email: item.email || "",
      phn_no: item.phn_no || "",
      password: "",
      password_confirmation: "",
      sales_limit: item.sales_limit || 0,
      branch: null,
      user_passcode: "",
      selectedBranch: item.branch_name ? { name: item.branch_name } : null,
      selectPermissionGroup: null,
      selectedPermissionGroup: null,
      user_dept: "",
      sbr_pos_id: item.sbr_pos_id || "",
      sbr_ntn: item.sbr_ntn || "",
      sbr_user_id: item.sbr_user_id || "",
      sbr_user_password: "",
      sbr_integration: item.sbr_enabled || 0,
      foc_limit: item.foc_limit || 0,
      is_cashier: (item.is_cashier === true || parseInt(item.is_cashier) === 1) ? 1 : 0,
      tillUser: null,
      orderType: null,
      default_order: item.default_order_name ? { name: item.default_order_name } : null,
      default_party: item.default_party_name ? { name: item.default_party_name } : null,
      image: item.image,
      edit: false,
      editSlug: item.slug,
      editImage: item.image,
      uploading: false,
      app_type: item.app_type || "",
    });
    handleSetEdit(item.id);
  };

  const COLUMNS = [
    {
      label: _t(t("S/L")),
      minWidth: "60px",
      render: (item, index) => (
        <span className={getRowTextClass(item)}>
          {searchedAdminStaff.searched
            ? index + 1
            : index +
              1 +
              ((adminStaffList?.current_page || 1) - 1) *
                (adminStaffList?.per_page || 0)}
        </span>
      ),
    },
    {
      label: _t(t("Image")),
      minWidth: "70px",
      render: (item) => (
        <div
          className="table-img-large mx-auto"
          style={{
            backgroundImage: `url(${
              item.image !== null ? item.image : "/assets/img/admin.png"
            })`,
          }}
        ></div>
      ),
    },
    {
      label: _t(t("Name")),
      minWidth: "140px",
      render: (item) => (
        <span className={`text-capitalize ${getRowTextClass(item)}`}>
          {item.name}
        </span>
      ),
    },
    {
      label: _t(t("Phn no")),
      minWidth: "120px",
      render: (item) => (
        <a
          href={`tel:${item.phn_no}`}
          rel="noopener noreferrer"
          className={getRowTextClass(item)}
        >
          {item.phn_no}
        </a>
      ),
    },
    {
      label: _t(t("Branch")),
      minWidth: "140px",
      render: (item) => (
        <span className={getRowTextClass(item)}>
          {item.branch_name || "-"}
        </span>
      ),
    },
    {
      label: _t(t("Permission Group")),
      minWidth: "140px",
      render: (item) => {
        let permissionGrp =
          permissionGroupForSearch &&
          permissionGroupForSearch.find(
            (group) => group.id === item.permission_group_id
          );
        return (
          <span className={getRowTextClass(item)}>
            {permissionGrp?.name || "-"}
          </span>
        );
      },
    },
    {
      label: _t(t("user type")),
      minWidth: "100px",
      render: (item) => (
        <span className={getRowTextClass(item)}>
          {item.user_type || "-"}
        </span>
      ),
    },
    {
      label: _t(t("ODT - Party")),
      minWidth: "150px",
      render: (item) => (
        <span className={getRowTextClass(item)}>
          {getOdtPartyDisplay(item)}
        </span>
      ),
    },
    {
      label: _t(t("Action")),
      minWidth: "140px",
      render: (item) => (
        <div className="d-flex align-items-center justify-content-center">
          <button
            type="button"
            className="btn btn-success ml-2 rounded-sm del-btn"
            onClick={() => handleOpenView(item)}
            data-toggle="modal"
            data-target="#viewUser"
            title={_t(t("View"))}
          >
            <i className="fa fa-eye"></i>
          </button>
          <button
            type="button"
            className="btn btn-primary ml-2 rounded-sm del-btn"
            onClick={() => handleOpenEdit(item)}
            data-toggle="modal"
            data-target="#addWaiter"
            title={_t(t("Edit"))}
          >
            <i className="fa fa-pencil"></i>
          </button>
          {item.user_type !== "superAdmin" && (
            <button
              type="button"
              className={`btn ${
                !parseInt(item.is_banned) ? "btn-danger" : "btn-success"
              } ml-2 rounded-sm del-btn`}
              onClick={() => {
                handleDisableConfirmation(
                  item.slug,
                  parseInt(item.is_banned)
                );
              }}
              title={!parseInt(item.is_banned) ? _t(t("Disable")) : _t(t("Enable"))}
            >
              {!parseInt(item.is_banned) ? (
                <i className="fa fa-times"></i>
              ) : (
                <i className="fa fa-check"></i>
              )}
            </button>
          )}
        </div>
      ),
    },
    {
      label: _t(t("Updated")),
      minWidth: "120px",
      render: (item) => (
        <span className={getRowTextClass(item)}>
          {item?.updated_at ? (
            <Moment format="LL">{item.updated_at}</Moment>
          ) : (
            "-"
          )}
        </span>
      ),
    },
  ];

  //disable adminStaff here
  const handleDisableUser = (slug) => {
    setLoading(true);
    const adminStaffUrl = BASE_URL + `/settings/delete-admin-staff/${slug}`;
    return axios
      .get(adminStaffUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setAdminStaffList(res.data[0]);
        setAdminStaffListforSearch(res.data[1]);
        setSearchedAdminStaff({
          ...searchedAdminStaff,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(`${_t(t("User has been disabled"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  //active confirmation modal of adminStaff
  const handleActiveConfirmation = (slug) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body bg-success">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">
              {_t(t("You want to active this user?"))}
            </p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-warning text-dark rounded"
                onClick={() => {
                  handleActiveUser(slug);
                  onClose();
                }}
              >
                {_t(t("Yes, please!"))}
              </button>
              <button className="btn btn-primary ml-2 px-3 rounded" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const handleIntegration = (item) => {
    let formData = new FormData();
    const url = BASE_URL + "/settings/enable-user-sbr-integration";
    formData.append("user_id", item.id);
    formData.append("sbr_enabled", !item?.sbr_enabled ? 1 : 0);

    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setAdminStaff({
          id: null,
          user_type: "",
          name: "",
          email: "",
          phn_no: "0",
          password: "",
          password_confirmation: "",
          branch: null,
          selectPermissionGroup: null,
          selectedBranch: null,
          selectedPermissionGroup: null,
          user_dept: "",
          sbr_pos_id: "",
          sbr_ntn: "",
          sbr_user_id: "",
          sbr_user_password: "",
          sbr_integration: 0,
          tillUser: null,
          orderType: null,
          image: null,
          edit: false,
          editSlug: null,
          editImage: null,
          uploading: false,
        });
        setAdminStaffList(res.data[0]);
        setAdminStaffListforSearch(res.data[1]);
        setLoading(false);
        toast.success(`${_t(t("User has been added"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        if (closeBtnRef.current) {
          closeBtnRef.current.click();
        };
      })
      .catch((error) => {
        setLoading(false);
      })
  }

  //Active adminStaff here
  const handleActiveUser = (slug) => {
    setLoading(true);
    const adminStaffUrl = BASE_URL + `/settings/delete-admin-staff/${slug}`;
    return axios
      .get(adminStaffUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        if (res.data === "noBranch") {
          setLoading(false);
          toast.error(
            `${_t(
              t(
                "The branch of this user not found, can not change active status"
              )
            )}`,
            {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            }
          );
        } else {
          setAdminStaffList(res.data[0]);
          setAdminStaffListforSearch(res.data[1]);
          setSearchedAdminStaff({
            ...searchedAdminStaff,
            list: res.data[1],
          });
          setLoading(false);
          toast.success(`${_t(t("User has been activated"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };


  return (
    <>
      <Helmet>
        <title>{_t(t("Users"))}</title>
      </Helmet>

      {/* Add modal */}
      <div className="modal fade" id="addWaiter" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content">
                <h5 className="text-capitalize fk-sm-card__title">
                  {!newAdminStaff.edit
                    ? _t(t("Add new admin / staff"))
                    : modalFetching
                    ? _t(t("Loading user details..."))
                    : _t(t("Update admin / staff"))}
                </h5>
              </div>
              <button
                type="button"
                ref={closeBtnRef}
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              {modalFetching ? (
                <div className="py-5 text-center">
                  <CustomSpinLoader loading={true} />
                  <div className="text-primary font-weight-bold text-uppercase mt-2">
                    {_t(t("Please wait"))}
                  </div>
                  <div className="text-muted sm-text mt-1">
                    {_t(t("Loading user details..."))}
                  </div>
                </div>
              ) : newAdminStaff.uploading === false ? (
                <div key="fragment-permission-1">
                  <form
                    onSubmit={
                      !newAdminStaff.edit
                        ? handleSaveNewAdminStaff
                        : handleUpdateAdminStaff
                    }
                    autoComplete="off"
                  >
                    {newAdminStaff.user_type === "superAdmin" ? (
                      <div>
                        <label htmlFor="user_type" className="form-label">
                          {_t(t("User type"))}{" "}
                          <small className="text-danger">*</small>
                        </label>
                        <select
                          name="user_type"
                          className="form-control"
                          onChange={handleSetNewUserType}
                          value={newAdminStaff.user_type}
                          disabled
                        >
                          <option value="superAdmin" className="text-uppercase">
                            {_t(t("Super Admin"))}
                          </option>
                        </select>
                      </div>
                    ) : (
                      <div>
                        <label htmlFor="user_type" className="form-label">
                          {_t(t("User type"))}{" "}
                          <small className="text-danger">*</small>
                        </label>
                        <select
                          name="user_type"
                          className="form-control"
                          onChange={handleSetNewUserType}
                          title="Please select an user type"
                          required
                          value={newAdminStaff.user_type}
                          onInvalid={handleInvalid}
                          ref={selectRef}
                        >
                          <option value="">
                            {_t(t("Please select an user type"))}
                          </option>
                          <option value="admin" className="text-uppercase">
                            {_t(t("Admin"))}
                          </option>
                          <option value="manager" className="text-uppercase">
                            {_t(t("Manager"))}
                          </option>
                          <option value="staff" className="text-uppercase">
                            {_t(t("Staff"))}
                          </option>
                          <option value="call_center" className="text-uppercase">
                            {_t(t("Call Center Staff"))}
                          </option>
                          <option value="multi_manager" className="text-uppercase">
                            {_t(t("Multi Branch Manager"))}
                          </option>
                          <option value="waiter" className="text-uppercase">
                            {_t(t("Waiter"))}
                          </option>
                        </select>
                      </div>
                    )}

                    <div className="mt-3">
                      <label htmlFor="name" className="form-label">
                        {_t(t("Name"))}{" "}
                        <small className="text-danger">*</small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder="e.g. Asif"
                        value={newAdminStaff.name || ""}
                        required
                        onChange={handleSetNewAdminStaff}
                      />
                    </div>

                    <div className="mt-3">
                      <label htmlFor="email" className="form-label">
                        {_t(t("Email"))}{" "}
                        <small className="text-danger">*</small>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="e.g. staff@example.com"
                        value={newAdminStaff.email || ""}
                        required
                        onChange={handleSetNewAdminStaff}
                      />
                    </div>

                    <div className="mt-3">
                      <label htmlFor="phn_no" className="form-label">
                        {_t(t("Phone number"))}{" "}
                        <small className="text-danger">*</small>
                      </label>
                      <input
                        type="text"
                        maxlength="12"
                        className="form-control"
                        id="phn_no"
                        name="phn_no"
                        placeholder="e.g. 01xxx xxx xxx"
                        value={newAdminStaff.phn_no || ""}
                        required
                        onChange={handleSetNewAdminStaff}
                      />
                    </div>

                    <div className="mt-3">
                      <label htmlFor="password" className="form-label">
                        {_t(t("Password"))}{" "}
                        {!newAdminStaff.edit && (
                          <small className="text-danger">*</small>
                        )}
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="password"
                        name="password"
                        placeholder="e.g. Password"
                        value={newAdminStaff.password || ""}
                        required={!newAdminStaff.edit}
                        onChange={handleSetNewAdminStaff}
                        readOnly
                        onFocus={(e) => e.target.removeAttribute("readOnly")}
                      />
                    </div>

                    <div className="mt-3">
                      <label
                        htmlFor="password_confirmation"
                        className="form-label"
                      >
                        {_t(t("Confirm Password"))}{" "}
                        {!newAdminStaff.edit && (
                          <small className="text-danger">*</small>
                        )}
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="password_confirmation"
                        name="password_confirmation"
                        placeholder="e.g. Confirm password"
                        value={newAdminStaff.password_confirmation || ""}
                        required={newAdminStaff.password !== ""}
                        onChange={handleSetNewAdminStaff}
                        readOnly
                        onFocus={(e) => e.target.removeAttribute("readOnly")}
                      />
                    </div>

                    {/* {newAdminStaff.user_type === "staff" && (<div className="mt-3">
                      <label
                        htmlFor="sales_limit"
                        className="form-label"
                      >
                        {_t(t("limit"))}{" "}
                        
                      </label>
                      <input
                        min={0}
                        type="number"
                        className="form-control"
                        id="sales_limit"
                        name="sales_limit"
                        placeholder="e.g. 100000"
                        value={newAdminStaff.sales_limit}                        
                        onChange={handleSetNewAdminStaff}
                      />
                    </div>)} */}

                    {(newAdminStaff.user_type === "staff" || newAdminStaff.user_type === "manager" || newAdminStaff.user_type === "multi_manager" || newAdminStaff.user_type === "waiter") && (
                      <>
                        <div className="mt-3">
                          <label className="form-label">
                            {_t(t("Select a branch"))}{" "}
                            {/*newAdminStaff.edit ? (
                            <small className="text-primary">
                              {"( "}
                              {_t(
                                t(
                                  "Leave empty if you do not want to change branch"
                                )
                              )}
                              {" )"}
                            </small>
                          ) : (
                          )*/}
                            <small className="text-danger">*</small>
                          </label>
                          {/*newAdminStaff.edit &&
                          newAdminStaff.selectedBranch !== null && (
                            <ul className="list-group list-group-horizontal-sm row col-12 mb-2 ml-md-1">
                              <li className="list-group-item col-12 col-md-3 bg-success rounded-sm py-1 px-2 my-1 text-center">
                                {newAdminStaff.selectedBranch.name}
                              </li>
                            </ul>
                          )*/}
                          <Select
                            options={branchForSearch}
                            //components={makeAnimated()}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            value={newAdminStaff.branch}
                            key={newAdminStaff.branch?.length}
                            isMulti={newAdminStaff.user_type === "multi_manager" ? true : false}
                            onChange={handleSetBranch}
                            placeholder={_t(t("Please select a branch"))}
                          />
                        </div>
                        <div className="mt-3">
                          <label htmlFor="user_passcode" className="form-label">
                            {_t(t("Passcode"))}{" "}
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            id="user_passcode"
                            name="user_passcode"
                            placeholder="e.g. Password"
                            value={newAdminStaff.user_passcode || ""}
                            onChange={handleSetNewAdminStaff}
                          />
                        </div>
                      </>
                    )}

                    {newAdminStaff.user_type !== "superAdmin" && (
                      <div className="mt-3">
                        <label className="form-label mb-0">
                          {_t(t("Select a permission group"))}{" "}
                          {newAdminStaff.edit ? (
                            <small className="text-primary">
                              {"( "}
                              {_t(
                                t(
                                  "Leave empty if you do not want to change permission group"
                                )
                              )}
                              {" )"}
                            </small>
                          ) : (
                            <small className="text-danger">*</small>
                          )}
                        </label>
                        {newAdminStaff.edit &&
                          newAdminStaff.selectedPermissionGroup !== null && (
                            <ul className="list-group list-group-horizontal-sm row col-12 mb-2 ml-md-1">
                              <li className="list-group-item col-12 col-md-3 bg-success rounded-sm py-1 px-2 my-1 text-center">
                                {newAdminStaff.selectedPermissionGroup.name}
                              </li>
                            </ul>
                          )}
                        <Select
                          options={permissionGroupForSearch}
                          components={makeAnimated()}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.name}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          value={newAdminStaff.selectPermissionGroup}
                          onChange={handleSetPermissionGroup}
                          placeholder={_t(t("Please select a group"))}
                        />
                      </div>
                    )}

                    {newAdminStaff.user_type !== "superAdmin" && (
                      <div className="row mt-3">
                        <div className="col-6">
                          <label className="form-label mb-0">
                            {_t(t("Order Type"))}
                          </label>
                          <Select
                            options={availableDeliveryTypes || []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            value={newAdminStaff.default_order}
                            onChange={handleSetDefaultOrder}
                            placeholder={_t(t("Please select order type"))}
                            isClearable={true}
                          />
                        </div>
                        <div className="col-6">
                          <label className="form-label mb-0">
                            {_t(t("Party"))}
                          </label>
                          <Select
                            options={newAdminStaff?.default_order?.id && availableDeliveryParties ? availableDeliveryParties[newAdminStaff.default_order?.id] || [] : []}
                            isDisabled={!newAdminStaff?.default_order}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            value={newAdminStaff?.default_order ? newAdminStaff.default_party : null}
                            onChange={handleSetDefaultParty}
                            placeholder={_t(t("Please select party"))}
                            isClearable={true}
                          />
                        </div>
                      </div>
                    )}

                    {(newAdminStaff.user_type === "staff" || newAdminStaff.user_type === "waiter" || newAdminStaff.user_type === "manager" || newAdminStaff.user_type === "call_center") && (
                      <div className="mt-3">
                        <label className="form-label mb-0">
                          {_t(t("Select Order Type"))}{" "}
                        </label>
                        <Select
                          value={newAdminStaff.orderType}
                          options={orderTypeForSearch && orderTypeForSearch}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          isMulti={true}
                          onChange={handleSetOrderTypeGroup}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder={_t(t("Please select order type"))}
                        />
                      </div>
                    )}

                    {(newAdminStaff.user_type === "staff" || newAdminStaff.user_type === "waiter") && (
                      <div className="mt-3">
                        <label className="form-label mb-0">
                          {_t(t("App Type"))}{" "}
                        </label>
                        <select
                          name="app_type"
                          className="form-control"
                          value={newAdminStaff.app_type || ""}
                          onChange={handleSetNewAdminStaff}
                        >
                          <option value="">{_t(t("Please select app type"))}</option>
                          <option value="waiter">{_t(t("Waiter"))}</option>
                          <option value="carhop">{_t(t("Carhop"))}</option>
                        </select>
                      </div>
                    )}

                    <div className="mt-3">
                      <label className="form-label">
                        {_t(t("Select Department"))}{" "}
                      </label>
                      <Select
                        options={foodDeptForSearch || []}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={newAdminStaff.user_dept}
                        key={newAdminStaff.user_dept?.length}
                        isMulti={(newAdminStaff.user_type === "staff") ? false : true}
                        onChange={handleSetDept}
                        placeholder={_t(t("Please select dept"))}
                      />
                    </div>

                    <div className="row mt-3">
                      <div className="col-3">
                        <label htmlFor="is_cashier" className="form-label d-block">
                          {_t(t("Is Cashier"))}
                        </label>
                        <input
                          type="checkbox"
                          className="form-check-input ml-2 mt-2"
                          id="is_cashier"
                          name="is_cashier"
                          checked={newAdminStaff.is_cashier === 1 || newAdminStaff.is_cashier === true}
                          onChange={handleSetNewAdminStaff}
                        />
                      </div>
                      <div className="col-9">
                        <label className="form-label" htmlFor="foc_limit">
                          {(t("FOC Daily Limit"))}
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="foc_limit"
                          name="foc_limit"
                          placeholder="e.g. 25,000"
                          value={newAdminStaff.foc_limit || null}
                          onChange={handleSetNewAdminStaff}
                        />
                      </div>
                    </div>

                    <div className="mt-3">
                      <div className="d-flex align-items-center mb-1">
                        <label htmlFor="image" className="form-label mb-0 mr-3">
                          {_t(t("Image"))}{" "}
                          <small className="text-secondary">
                            ({_t(t("300 x 300 Preferable"))})
                          </small>
                        </label>
                        {newAdminStaff.edit && (
                          <div
                            className="fk-language__flag"
                            style={{
                              backgroundImage: `url(${newAdminStaff.editImage})`,
                            }}
                          ></div>
                        )}
                      </div>
                      <input
                        type="file"
                        className="form-control"
                        id="image"
                        name="image"
                        onChange={handleAdminStaffImage}
                      />
                    </div>

                    {
                      (newAdminStaff.user_type === "staff" || newAdminStaff.user_type === "waiter" || newAdminStaff.user_type === "manager") && (
                        <div className="mt-3">
                          <label className="form-label mb-0">
                            {_t(t("Till User"))}{" "}
                          </label>
                          <Select
                            value={newAdminStaff.tillUser}
                            options={tillList && newAdminStaff.branch && tillList[newAdminStaff.branch.id]}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            onChange={(till) => handleSetTillUser(till)}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder={_t(t("Please select till"))}
                            isClearable
                          />
                        </div>
                      )
                    }

                    {/*
                      getSystemSettings(generalSettings, "user_wise_integration") == 1 && (newAdminStaff.user_type === "staff" || newAdminStaff.user_type === "manager") && (
                        <div className="mt-3 d-flex align-items-center">
                          <input
                            type="checkbox"
                            className="form-check-input mr-1 ml-3 mt-0"
                            id="sbrIntegration"
                            checked={newAdminStaff.sbr_integration === 1}
                            onChange={(e)=>{
                              setAdminStaff({
                                ...newAdminStaff,
                                sbr_integration: newAdminStaff.sbr_integration === 1 ? 0 : 1
                              })
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="sbrIntegration"
                          >
                            {_t(t("SBR Integration"))}
                          </label>
    
                        </div>
                      ) 
                    */}

                    {/*getSystemSettings(generalSettings, "user_wise_integration") == 1 && (newAdminStaff.user_type === "staff" || newAdminStaff.user_type === "manager") &&
                    (newAdminStaff.sbr_integration === true || newAdminStaff.sbr_integration === 1) && (
                       <div className="row">
                        <div className="mt-3 col-4 d-none">
                          <label className="form-label">
                            {_t(t("Payment Type"))}
                            {""}
                            <small className="text-danger">*</small>
                          </label>
                          <Select
                            value={newAdminStaff}
                            //options={}
                            // components={makeAnimated()}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.name}
                            className="basic-multi-select table-text"
                            classNamePrefix="select"
                            isMulti={true}
                            //onChange={handleSetPaymentType}
                               
                            // placeholder={_t(t("Please select "))}
                          />
                        </div>
                        <div className="mt-3 col-3">
                          <label htmlFor="sbr_ntn" className="form-label">
                            {_t(t("NTN"))}{" "}
                            <small className="text-danger">*</small>
                          </label>
                          <input
                            type="text"
                            className="form-control "
                            id="sbr_ntn"
                            name="sbr_ntn"
                            sbr_ntn="sbr_ntn"
                            value={newAdminStaff.sbr_ntn || ""}
                            required
                            onChange={handleSetNewAdminStaff}
                          />
                        </div>
                        <div className="mt-3 col-3">
                          <label htmlFor="sbr_pos_id" className="form-label">
                            {_t(t("Pos ID"))}{" "}
                            <small className="text-danger">*</small>
                          </label>
                          <input
                            type="text"
                            className="form-control "
                            id="sbr_pos_id"
                            name="sbr_pos_id"
                            sbr_pos_id="sbr_pos_id"
                            value={newAdminStaff.sbr_pos_id || ""}
                            required
                            onChange={handleSetNewAdminStaff}
                          />
                        </div>  
                        <div className="mt-3 col-3">
                          <label htmlFor="sbr_user_id" className="form-label">
                            {_t(t("User Id"))}{" "}
                            <small className="text-danger">*</small>
                          </label>
                          <input
                            type="text"
                            className="form-control "
                            id="sbr_user_id"
                            name="sbr_user_id"
                            sbr_user_id="sbr_user_id"
                            // placeholder="e.g. 6baffg110-386a-3f83-a8re-ff84f548351"
                            value={newAdminStaff.sbr_user_id || ""}
                            required
                            onChange={handleSetNewAdminStaff}
                          />
                        </div>

                        <div className="mt-3 col-3">
                          <label
                            htmlFor="sbr_user_password"
                            className="form-label"
                          >
                            {_t(t("Password"))}{" "}
                            <small className="text-danger">*</small>
                          </label>
                          <input
                            type="password"
                            className="form-control "
                            id="sbr_user_password"
                            name="sbr_user_password"
                            sbr_user_password="sbr_user_password"
                            value={newAdminStaff.sbr_user_password || ""}
                            required
                            onChange={handleSetNewAdminStaff}
                          />
                        </div>                          
                       </div>                           
                    )*/}

                    <div className="mt-4">
                      <div className="row d-flex justify-content-end">
                        <div className="col-3">
                          <button
                            type="submit"
                            className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          >
                            {!newAdminStaff.edit
                              ? _t(t("Save"))
                              : _t(t("Update"))}
                          </button>
                        </div>
                        <div className="col-3">
                          <button
                            type="button"
                            className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                            data-dismiss="modal"
                          >
                            {_t(t("Close"))}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                <div key="fragment2">
                  <div className="text-center text-primary font-weight-bold text-uppercase">
                    {_t(t("Please wait"))}
                  </div>
                  {modalLoading(3)}
                  <div className="mt-4">
                    <div className="row d-flex justify-content-end">
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          {!newAdminStaff.edit
                            ? _t(t("Save"))
                            : _t(t("Update"))}
                        </button>
                      </div>
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                          data-dismiss="modal"
                        >
                          {_t(t("Close"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Add modal Ends*/}

      {/* view modal */}
      <div className="modal fade" id="viewUser" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content">
                <h5 className="text-capitalize fk-sm-card__title">
                  {modalFetching ? _t(t("Loading user details...")) : newAdminStaff.name}
                </h5>
              </div>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              {modalFetching ? (
                <div className="py-5 text-center">
                  <CustomSpinLoader loading={true} />
                  <div className="text-primary font-weight-bold text-uppercase mt-2">
                    {_t(t("Please wait"))}
                  </div>
                  <div className="text-muted sm-text mt-1">
                    {_t(t("Loading user details..."))}
                  </div>
                </div>
              ) : (
                <table className="table table-striped table-sm text-center mt-3">
                <tbody>
                  <tr>
                    <td className="text-capitalized">{_t(t("User type"))}</td>
                    <td>{newAdminStaff.user_type}</td>
                  </tr>
                  <tr>
                    <td className="text-capitalized">{_t(t("Name"))}</td>
                    <td>{newAdminStaff.name}</td>
                  </tr>
                  <tr>
                    <td className="text-capitalized">{_t(t("Email"))}</td>
                    <td>{newAdminStaff.email}</td>
                  </tr>
                  <tr>
                    <td className="text-capitalized">
                      {_t(t("Phone number"))}
                    </td>
                    <td>{newAdminStaff.phn_no}</td>
                  </tr>
                  {newAdminStaff.user_type !== "superAdmin" &&
                    newAdminStaff.selectedPermissionGroup !== null && (
                      <tr>
                        <td className="text-capitalized">
                          {_t(t("Permission group"))}
                        </td>
                        <td>{newAdminStaff.selectedPermissionGroup.name}</td>
                      </tr>
                    )}

                  {(newAdminStaff.user_type === "staff" || newAdminStaff.user_type === "waiter" || newAdminStaff.user_type === "manager") &&
                    newAdminStaff.selectedBranch !== null && (
                      <tr>
                        <td className="text-capitalized">{_t(t("Branch"))}</td>
                        <td>{newAdminStaff.selectedBranch.name}</td>
                      </tr>
                    )}

                  {(newAdminStaff.default_order || newAdminStaff.default_party) && (
                    <tr>
                      <td className="text-capitalized">{_t(t("ODT - Party"))}</td>
                      <td>
                        {`${newAdminStaff.default_order?.name || "-"} - ${newAdminStaff.default_party?.name || "-"}`}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td className="text-capitalized">{_t(t("Is Cashier"))}</td>
                    <td>
                      {newAdminStaff.is_cashier === 1 || newAdminStaff.is_cashier === true
                        ? _t(t("Yes"))
                        : _t(t("No"))}
                    </td>
                  </tr>
                </tbody>
              </table>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* view modal Ends*/}

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="row mx-2 gx-2 align-items-center t-pt-15 t-pb-10">
                  <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                    <ul className="t-list fk-breadcrumb mb-0">
                      <li className="fk-breadcrumb__list">
                        <span className="t-link fk-breadcrumb__link text-capitalize">
                          {!searchedAdminStaff.searched
                            ? _t(t("User List"))
                            : _t(t("Search Result"))}
                        </span>
                      </li>
                    </ul>
                    <div className="text-muted xsm-text mt-0">
                      <span className="text-danger font-weight-bold">*</span>{" "}
                      {_t(
                        t(
                          "Users marked red are disabled, they can not login"
                        )
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-7">
                    <div className="row gx-3 align-items-center">
                      {/* Search group */}
                      <div className="col-md-9 t-mb-15 mb-md-0">
                        <div className="input-group">
                          <div className="form-file">
                            <input
                              ref={searchInputRef}
                              type="text"
                              className="form-control border-0 form-control--light-1 rounded-left"
                              placeholder={_t(t("Search")) + ".."}
                              onChange={handleSearch}
                              disabled={loading || dataPaginating}
                            />
                          </div>
                          <button
                            className="btn btn-primary rounded-right"
                            type="button"
                          >
                            <i
                              className="fa fa-search"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </div>
                      </div>

                      {/* Add group modal trigger button */}
                      <div className="col-md-3 text-md-right">
                        <button
                          type="button"
                          className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                          data-toggle="modal"
                          data-target="#addWaiter"
                          onClick={handleAddNewClick}
                        >
                          {_t(t("add new"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <DataTable
                loading={loading || dataPaginating}
                data={getListData()}
                columns={COLUMNS}
                emptyText="No data available"
                pagination={{
                  isPageLoading: loading,
                  isPagination: true,
                  pageCount: adminStaffList?.last_page,
                  currentPage: adminStaffList?.current_page,
                  from: adminStaffList?.from,
                  to: searchedAdminStaff.searched
                    ? searchedAdminStaff.list?.length || 0
                    : adminStaffList?.to,
                  total: searchedAdminStaff.searched
                    ? searchedAdminStaff.list?.length || 0
                    : adminStaffList?.total,
                }}
                handleFetchData={handleFetchData}
                searchPayload={{
                  isSearched: searchedAdminStaff.searched,
                  onClearSearch,
                }}
              />
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default AdminStaffCrud;
